module.exports = __webpack_public_path__ + "cfcceccfc7c76f4eadcbea6d5ee2ee33.jpg";